<child-header title="Order Status" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content>
  <div *ngIf="softwareSubscriptionApiResponse?.status =='Success'">
    <br />
    <div>
      You order has been placed with Microsoft, please allow 15 min for order fulfillment.  You will receive an invoice from Dicker Data following month with consolidated modern billing for all one time purchases.
    </div>
  </div>
  <div *ngIf="softwareSubscriptionApiResponse?.status =='Fail'">
    Something didn’t go to plan. Please do not try to reprocess this order. Contact Dicker Data Customer Support Team
    <br />
    <br />
    <div>
      {{softwareSubscriptionApiResponse?.message}}
    </div>
    <br />
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large" (click)="onNoClick()">OK</button>
  </div>
</div>